import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import AgentRegistry from './pages/AgentRegistry';
import WorkflowBuilder from './pages/WorkflowBuilder';
import GovernanceCenter from './pages/GovernanceCenter';
import ExecutionMonitor from './pages/ExecutionMonitor';
import Marketplace from './pages/Marketplace';
import Layout from './components/Layout';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="agents" element={<AgentRegistry />} />
            <Route path="workflows" element={<WorkflowBuilder />} />
            <Route path="governance" element={<GovernanceCenter />} />
            <Route path="executions" element={<ExecutionMonitor />} />
            <Route path="marketplace" element={<Marketplace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;